var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"type":"primary","loading":_vm.loading},on:{"click":_vm.exportExl}},[_vm._v("导出单位详细信息")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }